import { useMemo } from 'react';
import { object, string } from 'yup';

export function useQrCodeSchema() {
    return useMemo(
        () =>
            object().shape({
                name: string().required(),
                type: string().required(),
            }),
        [],
    );
}
